/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} DisputeTimesheetDetailsCandidateType
 * @property {ShiftRecordAddedComment} details
 * @property {Date} submittedDateUtc - Date timesheet was submitted
 * @property {TimesheetModificationsViewModel} modifications - List of modifications changing the original booking times
 */

import TimesheetModificationsViewModel from './timesheetModificationsViewModel'
import DisputeTimesheetDetails from './disputeTimesheetDetails'
import ShiftRecordAddedComment from './shiftRecordAddedComment'

/**
 * @class
 */
export default class DisputeTimesheetDetailsCandidate extends DisputeTimesheetDetails {
  /**
   * Create a new DisputeTimesheetDetailsCandidate.
   * @param {DisputeTimesheetDetailsCandidateType} params
   */
  constructor(params) {
    super(params)
    this.details = params.details
      ? new ShiftRecordAddedComment(params.details)
      : null
  }
}
